import Vue from 'vue'
import Vuex from 'vuex'
import { User } from "firebase/auth"
import { ActionLinkParams} from "@/scripts/datatypes"
import { SchoolPublicProfile,UserPrivateProfile,UserPublicProfile,CustomClaims, UserRelationship, Role} from "../common-datatypes";

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: undefined as User | null | undefined,
		claims:undefined as CustomClaims | null | undefined,
    school:undefined as SchoolPublicProfile | null | undefined,
    userPublicProfile:undefined as UserPublicProfile | null | undefined,
    userPrivateProfile:undefined as UserPrivateProfile | null | undefined,
    userRelationship:undefined as UserRelationship | null | undefined,
		lang:undefined as null | undefined,
    isLoading:false as boolean,
    actionLink: undefined as ActionLinkParams | null | undefined,
    hasInvitation: false,
	},
	mutations: {
		setUser(state, user: User | null) {
			state.user = {...user} as User
		},
		setCustomClaims(state, claims: CustomClaims | undefined) {
			state.claims = (claims) ? {...claims} as CustomClaims : undefined
		},
		setSchool(state, school: SchoolPublicProfile | null) {
			state.school = (school) ? {...school} : null
    },
		setUserPublicProfile(state, userPublicProfile: UserPublicProfile | null) {
			state.userPublicProfile = (userPublicProfile) ? {...userPublicProfile} : null
    },
    setUserPrivateProfile(state, userPrivateProfile: UserPrivateProfile | null) {
			state.userPrivateProfile = (userPrivateProfile) ? {...userPrivateProfile} : null
		},
    setUserRelationship(state, userRelationship: UserRelationship | null) {
			state.userRelationship = (userRelationship) ? {...userRelationship} : null
		},
		setLang(state, lang: undefined | null) {
			state.lang = lang
		},
		setLoading(state, isLoading: boolean) {
			state.isLoading = isLoading
    },
    setActionLink(state, actionLink: ActionLinkParams | null) {
			state.actionLink = actionLink ? {...actionLink} : null
		},
    setHasInvitation(state, hasInvitation: boolean) {
			state.hasInvitation = hasInvitation
		},
	},
	getters: {
		lang: function(state): string {
			if(state.lang){
				return state.lang
			}
			return ''
		},
		userLang: function(state) {
			if(state.userPrivateProfile && state.userPrivateProfile.lang ){
				return state.userPrivateProfile.lang
			}
			return ''
		},
		uid: function(state) {
			if(state.user && state.user.uid ){
				return state.user.uid
			}
			return ''
    },
    roles: function(state) {
      if(state.userPublicProfile && state.userPublicProfile.roles){
        return state.userPublicProfile.roles
      }

			return []
		},
    isStaff: function(state,getters) {
      return getters.roles.some((role: Role) => {
        return ['owner','admin','staff'].includes(role)
      })
		},
    myChildren: function(state,getters) {
      if(getters.roles.includes('parent') && state.userRelationship?.children){
        return state.userRelationship?.children
      }
      return []
    },
    myParents: function(state,getters) {
      if(getters.roles.includes('child') && state.userRelationship?.parents){
        return state.userRelationship?.parents
      }
      return []
    },
    userId: function(state,getters){
      if(getters.schoolId && getters.schools[getters.schoolId] && getters.schools[getters.schoolId].userId){
				return getters.schools[getters.schoolId].userId as string
			}
			return ''
		},
    schoolName: function(state) {
			if(state.school && state.school.schoolName ){
				return state.school.schoolName
			}
			return ''
		},
		schoolId: function(state): string {
			if(state.claims && state.claims.selectedSchoolId){
				return state.claims.selectedSchoolId 
			}
			return ''
    },
    disabled: function(state,getters){
      if(! getters.schoolId || ! getters.schools[getters.schoolId] || typeof getters.schools[getters.schoolId].disabled !== 'boolean'){
        return null
      }

      if(getters.schools[getters.schoolId].disabled === true){
        return true
      }

      return false
    },
    schools: function(state){
      if(state.claims && typeof state.claims.schools === 'object'){
        return state.claims.schools
      }
      return {}
    },
    invited: function(state,getters){
      if(state.claims && typeof state.claims.schools === 'object' && getters.numSchools === 0 && state.claims.selectedSchoolId === undefined){
        return true
      }
      return false
    },
    noSchool: function(state,getters){
      if(state.claims && typeof state.claims.schools === 'object' && getters.numSchools === 0 && state.claims.selectedSchoolId === ''){
        return true
      }
      return false
    },
    signedUp: function(state){
      if(state.user && state.user.uid && ! state.claims){
        return true
      }
      return false
    },
    numSchools: function(state,getters){
      return Object.keys(getters.schools).length
    },
		loading: function(state) {
			return state.isLoading
    },
    actionLinkMode: function(state) {
      if(state.actionLink && state.actionLink.mode){
        return state.actionLink.mode
      }else{
        return ''
      }
    },
    actionLinkAction: function(state) {
      if(state.actionLink && state.actionLink.action){
      return state.actionLink.action
      }else{
        return ''
      }
    },
    actionLinkCode: function(state) {
      if(state.actionLink && state.actionLink.actionCode){
      return state.actionLink.actionCode
      }else{
        return ''
      }
    },
    actionLinkToken: function(state) {
      if(state.actionLink && state.actionLink.token){
        return state.actionLink.token
      }else{
        return ''
      }
    },
    actionLinkUid: function(state) {
      if(state.actionLink && state.actionLink.uid){
        return state.actionLink.uid
      }else{
        return ''
      }
    },
    actionLinkContinueUrl: function(state) {
      if(state.actionLink && state.actionLink.continueUrl){
        return state.actionLink.continueUrl
      }else{
        return ''
      }
    },
    timeZone: function(state){
      if(state.userPrivateProfile && state.userPrivateProfile.timeZone){
        return state.userPrivateProfile.timeZone
      }
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    }
	},
	actions: {
	},
	modules: {
	}
})
